import PD_SectionOne from "./PD_SectionOne";

function Products_Details() {
  return (
    <>
      <main>
        <PD_SectionOne />
      </main>
    </>
  );
}

export default Products_Details;
